module.exports = __webpack_public_path__ + "media/images/icons/stats-3ca95826c1279c3dbb17e5abe4c50bc5.svg";